import { TableCell } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import Check from '@material-ui/icons/Check';
import { toast } from 'react-toastify';

const TableAdminCheckboxSection = ({
  mailingOption,
  t,
  state,
  setState,
  classes,
}) => (
  <TableCell>
    {mailingOption.mailKey !== 'diet_reminder' && (
      <Checkbox
        checked={
          mailingOption.managedBySystem ? true : mailingOption.enabledForOffice
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars, consistent-return -- FIXME
        onChange={e => {
          if (mailingOption.managedBySystem) {
            return toast.warning(
              `${t('mailNotifications.thisIsASystemNotification')} ${t(
                'mailNotifications.cannotDisabeSystemNotification'
              )}`
            );
          }

          const newMailing = [...state.mailing];

          const optionToChange = newMailing.find(
            newMailingOption => newMailingOption.id === mailingOption.id
          );

          optionToChange.enabledForOffice = !mailingOption.enabledForOffice;
          optionToChange.hasChanged = true;

          setState({
            mailing: newMailing,
          });
        }}
        checkedIcon={<Check className={classes.checkedIcon} />}
        icon={<Check className={classes.uncheckedIcon} />}
        classes={{
          checked: classes.checked,
          root: classes.checkRoot,
        }}
      />
    )}
  </TableCell>
);

export default TableAdminCheckboxSection;
